export default __webpack_public_path__ + "static/ipad-p-b3baa78612fa151b4a44ec0929c40241.jpg";